/**
 * Display name used in the UI for the atlassian-web-crawler knowledge source.
 * Kept in one place so all app-filter call sites stay in sync (see search-page mapping).
 */
const ATLASSIAN_WEB_CRAWLER_SOURCE = 'atlassian-web-crawler';
const ATLASSIAN_WEB_CRAWLER_DISPLAY_NAME = 'Web pages';

/**
 * Returns the display name for a knowledge source.
 * Handles special cases (e.g. atlassian-web-crawler → "Web pages") so callers don't duplicate this logic.
 */
export function getKnowledgeSourceDisplayName(source: string, friendlyName: string): string {
	return source === ATLASSIAN_WEB_CRAWLER_SOURCE
		? ATLASSIAN_WEB_CRAWLER_DISPLAY_NAME
		: friendlyName;
}
